/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Matching_Shippeek_RateInputs */

const en_orders_no_matching_shippeek_rate = /** @type {(inputs: Orders_No_Matching_Shippeek_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching ShipPeek rate found yet.`)
};

const es_orders_no_matching_shippeek_rate = /** @type {(inputs: Orders_No_Matching_Shippeek_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aun no se encontro una tarifa ShipPeek que coincida.`)
};

/**
* | output |
* | --- |
* | "No matching ShipPeek rate found yet." |
*
* @param {Orders_No_Matching_Shippeek_RateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_matching_shippeek_rate = /** @type {((inputs?: Orders_No_Matching_Shippeek_RateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Matching_Shippeek_RateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_matching_shippeek_rate(inputs)
	return es_orders_no_matching_shippeek_rate(inputs)
});